module.exports = __webpack_public_path__ + "img/stock7.b6b33c77.png";